import api from "../api/api";
import { appState } from "../redux/redux-config";


const contacts = {
    load: async (search, page, pageSize, skipTotal) => {
        let token = appState().user.token;
        let result = await api.contacts.list(token, search, page, pageSize, skipTotal);
        if (result.success) {
            return {
                list: result.contacts.map(c => ({ id: c.id, name: c.firstName + (c.middleName ? " " + c.middleName : "") + " " + c.lastName })),
                totalCount: result.totalCount
            };
        }
    },

    InvalidContacts: async() => {
      let token = appState().user.token;   
      let result = await api.contacts.InvalidContacts(token);
      if (result.success) {
          return result;
      }
    },

    DeleteContacts: async function (selectedContactIds) {
        let token = appState().user.token;
        let result = await api.contacts.DeleteContacts(token, selectedContactIds);
        if (result.success) {
            return result;
        }
    }
}
export default contacts;